<template>
  <div
    class="d-flex-column flex-85 justify-start align-start t-white gap-36 mobile-min-heigh"
  >
    <!-- <p class="t-white">{{ childPacks }}</p> -->
    <div class="category_pack_container">
      <PackCard
        v-for="(pack, index) in childPacks"
        :title="pack.short_title"
        :perks="pack.perks"
        :image="pack.image"
        :slug="pack.slug"
        :link="`/${currentGameSlug}/${currentGamePackSlug}/${pack.slug}`"
        :index="index"
        :current-game-slug="currentGameSlug"
      />
    </div>
  </div>
</template>

<script setup>
import PackCard from "~/components/cards/PackCard.vue";

const gameStore = useGameStore();
const { currentGameSlug, currentGamePackSlug } = useGameComposable();

const childPacks = computed(() => {
  const packs = gameStore.getGamePack?.child_packs || [];
  return packs;
});
</script>
